import request from '@/utils/request';

/**
 * 通过后端代理调用腾讯 IP 定位
 * @param {string} ip - IP 地址（可选，不传则自动获取）
 * @returns {Promise<Object>} 返回定位信息 {lng, lat, city, province, address}
 */
export async function getLocationByIP(ip = '') {
  try {
    console.log('调用后端腾讯IP定位接口...');
    
    // 调用你的后端代理接口（使用统一的 request，会自动处理加密解密）
    const params = {};
    if (ip) {
      params.ip = ip;
    }
    
    const response = await request.post('/mx/ip-location', params);

    console.log('腾讯IP定位响应:', response);

    // response.data 已经被 request.js 自动解密了
    if (response && response.data) {
      const result = response.data;
      return {
        lng: result.location.lng,
        lat: result.location.lat,
        city: result.ad_info.city,
        province: result.ad_info.province,
        district: result.ad_info.district,
        address: `${result.ad_info.province}${result.ad_info.city}${result.ad_info.district}`,
        nation: result.ad_info.nation
      };
    } else {
      throw new Error('IP定位失败');
    }
  } catch (error) {
    console.error('腾讯IP定位失败:', error);
    throw error;
  }
}

/**
 * 通过浏览器 Geolocation API 获取定位
 * @returns {Promise<Object>} 返回定位信息 {lng, lat}
 */
export function getBrowserLocation() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('浏览器不支持定位功能'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lng: position.coords.longitude,
          lat: position.coords.latitude,
          accuracy: position.coords.accuracy
        });
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
    );
  });
}

/**
 * 综合定位方法：优先使用浏览器定位，失败则使用 IP 定位
 * @returns {Promise<Object>} 返回定位信息
 */
export async function getLocation() {
  try {
    // 优先尝试浏览器定位
    console.log('尝试使用浏览器定位...');
    const browserLocation = await getBrowserLocation();
    console.log('浏览器定位成功:', browserLocation);
    return {
      ...browserLocation,
      type: 'browser'
    };
  } catch (browserError) {
    console.warn('浏览器定位失败，尝试使用IP定位:', browserError.message);
    
    try {
      // 浏览器定位失败，使用 IP 定位
      const ipLocation = await getLocationByIP();
      console.log('IP定位成功:', ipLocation);
      return {
        ...ipLocation,
        type: 'ip'
      };
    } catch (ipError) {
      console.error('IP定位也失败:', ipError.message);
      
      // 两种定位都失败，返回默认位置（广州）
      return {
        lng: 113.264359,
        lat: 23.129080,
        city: '广州市',
        province: '广东省',
        address: '广东省广州市',
        type: 'default'
      };
    }
  }
}

export default {
  getLocation,
  getLocationByIP,
  getBrowserLocation
};
